import { createFileRoute } from "@tanstack/react-router";
import { OnboardingBoardPage } from "@/features/onboarding/OnboardingBoardPage";

export const Route = createFileRoute("/_app/onboarding/")({ component: OnboardingBoardPage });
